module.exports = __webpack_public_path__ + "static/media/mbys_los_of_sme.1d91fa31.png";